<template>
  <div class="hp-base-panel-wrp">
    <div class="upgrade-pkgs hp-base-panel">
      <div class="top">
        <span class="title">倾诉套餐({{ activities.length }})</span>
      </div>
      <div :class="['pkgs-wrap', { 'only-one': activities.length === 1 }]">
        <updgradePkg
          v-for="(item, index) in activities"
          :key="item.id"
          :item="item"
          @select="onSelect"
          @onBuy="onBuy(item, index)"
        />
      </div>
    </div>
    <qingsuModel
      :show.sync="showQingsuPkgModel"
      :msg="pkgMsg"
      :customClose="true"
      @customClose="onClose"
    />
  </div>
</template>

<script>
import updgradePkg from './upgradePkg.vue'
import { EventBus } from 'component/platform/homepage/eventBus.js'
import { mapState } from 'vuex'
import { decodeUrlQuery } from 'app/frontend-lib/tools/utils.js'
import qingsuModel from './qingsuModel.vue'

export default {
  components: {
    updgradePkg,
    qingsuModel
  },
  props: {
    activities: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState('homepage', {
      basicInfo: 'basicInfo',
      qingsuService: 'qingsuService',
      qingsuVisit: 'qingsuVisit'
    })
  },
  data() {
    return {
      showQingsuPkgModel: false,
      pkgMsg: {}
    }
  },
  methods: {
    onBuy(item, index) {
      const userId = this.$route.params.userId
      const { id, title } = item
      const { channel_flag = '', cid = '', _source_page_ } = this.$route.query
      this.$trackEvent('newprofilepages_listener_package_click', {
        listener_id: userId,
        listener_name: this.basicInfo.nickname,
        listener_state: ['已休息', '空闲', '服务中'][
          this.qingsuService.info.ting_status
        ],
        source_page: _source_page_ ? decodeUrlQuery(_source_page_) : '',
        is_newlistenvisitor: this.qingsuVisit.is_new_visit,
        is_newlistenervisitor: this.qingsuVisit.is_new_teacher_visit,
        channel_flag,
        cid,
        qs_package_id: id,
        qs_package_name: title,
        item_location: index + 1
      })
      EventBus.$emit('toQingsuOrder', {
        path: '/qingsu-order-page',
        query: {
          to_user_id: userId,
          pkgId: item.id
        }
      })
    },
    onSelect(item) {
      const { id, title } = item
      this.pkgMsg = {
        modelTitle: '套餐说明',
        label: '立即购买',
        ...item
      }
      this.showQingsuPkgModel = true
      this.$trackEvent('newprofilepages_listener_package_explain', {
        qs_package_id: id,
        qs_package_name: title
      })
    },
    onClose() {
      const { id } = this.pkgMsg
      const item = this.activities.find(item => item.id === id)
      const index = this.activities.findIndex(item => item.id === id)
      this.onBuy(item, index)
    }
  }
}
</script>

<style lang="scss" scoped>
.upgrade-pkgs {
  padding-right: 0 !important;
}
.hp-base-panel-wrp {
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 30px;
    .title {
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 700;
      color: #21252d;
      line-height: 32px;
    }
  }
  .pkgs-wrap {
    display: flex;
    padding-top: 40px;
    overflow: scroll;
    /deep/ .pkg {
      margin-right: 25px;
    }
    &.only-one {
      /deep/ .pkg {
        margin-left: 12px;
      }
    }
  }
}
</style>
